<template>
	<div class="site-info-row">
		<div class="site-info-row__head">
			<div class="site-info-row__title">
				{{ title }}
			</div>
			<div class="site-info-row__line"></div>
		</div>
		<div class="site-info-row__body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "InfoRow",
	props: {
		title: { required: true, type: String },
	}
};
</script>

<style lang="scss" scoped>
.site-info-row {
	&__head {
		display: flex;
	}

	&__title {
		font-size: 16px;
		font-weight: 600;
		line-height: 13px;
	}

	&__line {
		flex-grow: 1;
		border-bottom: rgba(98, 98, 98, 0.7) solid 2px;
		margin-left: 13px;
	}

	&__body {
		margin-top: 23px;
	}
}
</style>
